/*eslint-disable */
<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">{{ cvCardTitle }}</h4>
          </template>
          <template v-slot:body>
            <ValidationObserver v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(quizBankAdd)">
                <div class="form-row">
                  <!-- Question serial number -->
                  <div class="col-md-12 mb-3">
                    <label>{{ cvSerialNo }}</label>
                    <ValidationProvider
                      name="Question serial number"
                      rules="required"
                      v-slot="{ errors }">
                      <input
                        v-model="vmQuestionBankFormData.serial_no"
                        type="text"
                        class="form-control"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <!-- Question serial number -->

                  <!-- qbk category -->
                  <div class="col-md-12 mb-3">
                    <label for="validationqbkcategory">{{ cvQbkCategoryLabel }}</label><br/>
                    <ValidationProvider
                      name="Question Bank Category"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <multiselect
                        v-model="vmQuestionBankFormData.qbk_category_option"
                        :options="vmqbkcategoryList"
                        :multiple="false"
                        :taggable="true"
                        @tag="addCategory"
                        placeholder="Search & Select"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <!-- qbk category -->

                  <!-- type -->
                  <div class="col-md-12 mb-3">
                    <label for="validationcategory">Select Type</label><br/>
                    <select v-model="vmQuestionBankFormData.is_mcq" class="form-control">
                      <option :value="1">MCQ</option>
                      <option :value="0">ESSAY TYPE / Free Response Answer (FRA)</option>
                    </select>
                  </div>
                  <!-- type -->

                  <!-- Is Essay Type Numeric. Show Only for ESSAY TYPE-->
                  <div class="col-12 col-md-6 mb-3 gide_inline_textorcheckbox" v-if="vmQuestionBankFormData.is_mcq == '0'">
                    <ValidationProvider  v-slot="{ errors }">
                      <div class="d-flex align-items-center">
                        <label class="ml-2 mb-0" for="is_essay_type_numeric">{{ cvIsEssayTypeNumeric }}</label>
                        <input id="is_essay_type_numeric" v-model="vmQuestionBankFormData.is_essay_type_numeric" type="checkbox" class="form-control"/>
                      </div>
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </ValidationProvider>
                  </div><!-- Is Essay Type Numeric. Show Only for ESSAY TYPE-->
                  <!-- Is allowed to upload image. Show Only for ESSAY TYPE-->
                  <div class="col-12 col-md-6 mb-3 gide_inline_textorcheckbox ms-md-3" v-if="vmQuestionBankFormData.is_mcq == '0'">
                    <ValidationProvider  v-slot="{ errors }">
                      <div class="d-flex align-items-center">
                        <label class="ml-2 mb-0" for="is_allowed_to_img_upload">{{ cvIsAllowedToImageUpload }}</label>
                        <input id="is_allowed_to_img_upload" v-model="vmQuestionBankFormData.is_allowed_to_img_upload" type="checkbox" class="form-control"/>
                      </div>
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </ValidationProvider>
                  </div><!-- Is allowed to upload image. Show Only for ESSAY TYPE-->

                  <!-- Question -->
                  <div class="col-md-12 mb-3">
                    <label for="validationquestion">{{ cvQuestionLabel }}</label>
                    <ValidationProvider
                      name="Question"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <template>
                        <vue-editor class="katex" :editorToolbar="customToolbarAdmin" v-model="vmQuestionBankFormData.question"></vue-editor>
                      </template>
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div><!-- /Question -->

                  <!-- difficulty -->
                  <div class="col-md-12 mb-3">
                    <label for="app_name">{{ cvAppDifficultyLebel }}</label>
                    <ValidationProvider
                      name="Question Difficulty"
                      rules="required"
                      v-slot="{ errors }">
                      <select class="form-control" v-model="vmQuestionBankFormData.difficulty">
                        <option disabled value="">Select difficulty</option>
                        <option value="easy">Easy</option>
                        <option value="medium">Medium</option>
                        <option value="hard">Hard</option>
                      </select>
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </ValidationProvider>
                  </div><!-- difficulty -->

                  <div class="col-md-12 mb-3">
                    <label for="app_name">{{ cvAppSkillLebel }}</label>
                    <ValidationProvider
                      name="Question skill cannot be empty"
                      rules="required"
                      v-slot="{ errors }">
                      <input v-model="vmQuestionBankFormData.skill" type="text" class="form-control mb-0" >
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </ValidationProvider>
                  </div>

                  <div class="mt-4 w-100">
                    <h4 class="mb-3">{{ cvPBACoverPic }} : {{ imageSize }}</h4>

                    <!-- question picture -->
                    <div class="form-group row align-items-center">
                      <div class="col-md-12">
                        <div class="profile-img-edit border" style="height: 200px; width: 300px;">
                          <img v-if="vmCoverPic" :src="vmCoverPic" alt="profile-pic " style="height: 100%; width: 100%; object-fit: cover; overflow: hidden;" />
                          <i v-else class="fas fa-image d-flex justify-content-center align-items-center" style="font-size: 5rem; height:100%; color: #c1c1c1;"></i>
                          <label class="p-image">
                            <i class="ri-pencil-line upload-button" style="cursor: pointer;"></i>
                            <input class="file-upload" type="file" accept="image/png,image/jpeg,image/jpg" id="fileInput1" style="display: block; position: absolute; opacity: 0; left: 0; top: 0; pointer-events: none;" @change="openImageDialog($event, 'Cover Pic')" />
                          </label>
                          <span class="text-danger" ref="coverPicError"></span>
                        </div>
                      </div>
                    </div>
                    <!-- question picture -->

                    <!-- Add Answer options -->
                    <template v-if="vmQuestionBankFormData.is_mcq == 1">
                      <div class="form-group col-12 markRow">
                      <div> <label for="correctedOption">{{cvoptionAnswersLabel}}</label></div>
                        <span class="addIcon pointer" @click="addOption()">Add Option <i class="fa-solid fa-circle-plus"></i></span>
                      </div>
                      <div :key="update" class="row w-100">
                        <div class="form-group w-100">
                          <template v-for="(val, option) in vmQuestionBankFormData.answer_choices" >
                            <div class="col-12 answerOption mt-1" :key="option">
                              <span class="badge bg-primary text-white rounded-pill optionAddSpan">{{option}}</span>
                              <!-- <input v-model="vmQuestionBankFormData.answer_choices[option]" type="text" class="form-control mb-0" id="marks"> -->
                              <span class="addIcon answerOptionAddBtn" @click="removeOption(option)"><i class="fa-solid fa-circle-xmark"></i></span>
                              <vue-editor class="katex" :editorToolbar="customToolbarAdmin" v-model="vmQuestionBankFormData.answer_choices[option]"></vue-editor>
                            </div>
                          </template>
                        </div>
                      </div>
                    </template>
                    <!-- Add Answer options end -->

                    <!-- Correct Answer -->
                    <div class="col-md-12 mb-3">
                      <label for="validationcorrect_answers">{{ cvCorrectAnswersLabel }}</label>
                      <ValidationProvider
                        name="Correct answer"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <input v-model="vmQuestionBankFormData.correct_answers" type="text" class="form-control"/>
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                    <!-- /Correct Answer -->

                    <!-- Question Marks -->
                    <div class="col-md-12 mb-3">
                      <label>{{ cvQuestionPointsLabel }}</label>
                      <ValidationProvider
                        name="Question points"
                        rules="required|min_value:1"
                        v-slot="{ errors }"
                      >
                        <input v-model.number="vmQuestionBankFormData.question_points" type="number" class="form-control"/>
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                    <!-- Question Marks -->

                    <!-- Answer explanation -->
                    <div class="col-md-12 mb-3">
                      <label for="validationcorrect_answers">{{ cvExplanationLabel }}</label>
                      <template>
                        <vue-editor class="katex" :editorToolbar="customToolbarAdmin" v-model="vmQuestionBankFormData.answer_explanation"></vue-editor>
                      </template>
                    </div>
                    <!-- /Answer Explanation -->

                    <!-- Show Calculator -->
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-3 gide_inline_textorcheckbox">
                      <label class="lable" for="app_has_calc">{{ cvExamCalcReq }}</label>
                      <ValidationProvider
                        name="Show Calculator for this Question "
                        v-slot="{ errors }">
                        <input id="" v-model="vmQuestionBankFormData.has_calc" type="checkbox" class="form-control" />
                        <span class="text-danger"> {{ errors[0] }} </span>
                      </ValidationProvider>
                    </div>
                    <!-- Show Calculator -->
                  </div>
                </div>
                <div class="row spinner_add">
                  <div class="col-7">
                  <button type="submit" class="btn btn-primary">{{ cvSubmitBtn }}</button>
                </div>
                  <div class="col-5">
                    <button  v-if="cvLoadingStatus" type="button" class="btn btn-primary float-right" :disabled="cvLoadingStatus">
                      <b-spinner label="Spinning"></b-spinner>
                    </button>
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <CropImage :prop-crop-image-dialog-open="propCropImageDialogOpen" :propCropModalSize="propCropDialogSize" :prop-stencil-size="propStencilSize" :propSrc="fileSrc" @emitCroppedImg="getCroppedImg" @emitCroppedImgFile="emitCroppedImgFile" />
    <b-toast v-model="showToast" name="Toast" :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
      :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<style scoped lang="scss">
  .fa-circle-plus{
    font-size: 16px;
    position: relative;
    top: 1px;
    float: right;
    color: #fb0000;
  }
  .answerOption {
    position: relative;
  }
  .answerOptionAddBtn {
    position: absolute;
    font-size: 20px;
    top: 7px;
    right: 5px;
  }
  .form-group {
    input {
      margin-left: 10px;
    }
  }
  .optionAddSpan {
    position: relative;
    height: 20px;
    top: 10px;
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import { QuizBanks } from "../../../FackApi/api/quizBank.js"
import ApiResponse from "../../../Utils/apiResponse.js"
import CropImage from "../../../components/cropImage.vue"
import QuizType from "../../../FackApi/json/QuizType.js"
import { VueEditor } from "vue2-editor"
import userPermission from "../../../Utils/user_permission"
import { socialvue } from "../../../config/pluginInit.js"
import "katex/dist/katex.min.css"
import katex from "katex"
import { base64encode } from "nodejs-base64"
import { ValidationProvider, ValidationObserver, extend } from "vee-validate"
import { required, min_value as minValue } from "vee-validate/dist/rules"
import Multiselect from "vue-multiselect"

// required rule
extend("required", {
  ...required,
  message: "{_field_} is required"
})
// custom message for min_value
extend("min_value", {
  ...minValue,
  message: "Question points should be min 1"
})

export default {
  name: "QuestionBankAdd",
  components: {
    CropImage,
    VueEditor,
    ValidationProvider,
    ValidationObserver,
    Multiselect
  },
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propAppId: {
      type: String,
      default: null
    },
    propAppCategory: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      apiName: "quiz_bank_add",
      cvCardTitle: "Add Question",
      cvSubmitBtn: "Add",
      cvCategoryLabel: "Quiz Category",
      cvQbkCategoryLabel: "Question Bank Category",
      cvQuestionLabel: "Question",
      cvAppDifficultyLebel: "Difficulty",
      cvAppSkillLebel: "Skill or Tag",
      cvAnswerChoicesLabel: "Answer Choices",
      cvCorrectAnswersLabel: "Correct Answer",
      cvQuestionPointsLabel: "Question Marks",
      cvExplanationLabel: "Answer Explanation",
      cvoptionAnswersLabel: "Options Answers",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      cvLoadingStatus: false,
      toastTitle: "Question Bank",
      vmQuestionBankFormData: Object.assign({}, this.initFormData()),
      cvPBACoverPic: "Does this Question have a Picture ? If yes then upload ",
      cvSerialNo: "Question serial number (Ex. 1, 2, 3, 4, ......100, ...",
      vmQuestionBankDesc: null,
      vmQuestionBankType: null,
      vmqbkExamCategoryList: " ",
      vmqbkExamCategoryData: " ",
      vmqbkcategoryList: [],
      app_id: "",
      propCropDialogSize: "md",
      propCropImageDialogOpen: false,
      vmCoverPic: "",
      propStencilSize: null,
      fileSrc: "",
      vmPBACoverPicImage: Object.assign({}, this.initImageData()),
      isPhotoUploaded: false,
      imageMaxSize: " Maximum Size 4MB",
      quizDetail: {},
      QuizType: QuizType,
      imageSize: "Size  1080 * 566",
      cvExamCalcReq: "Show Calculator for this Question ?",
      cvIsEssayTypeNumeric: "Is Essay / Free Response Answer (FRA) Type Numeric ?",
      cvIsAllowedToImageUpload: "Is Allowed to Upload Document ?",
      update: 0,
      customToolbarAdmin: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [{ "script": "super" }, { "script": "sub" }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ["link", "image", "video", "formula"],
        ["clean"] // remove formatting button
      ],
      cvImageSizeErrorMsg: " Image size must be less than 300 kb."
    }
  },
  computed: {
    userData () {
      return { ...this.$store.getters["User/userData"] }
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  mounted () {
    socialvue.index()
    window.katex = katex

    if (this.$route.params.app_id) {
      this.app_id = this.$route.params.app_id
    }
    else if (this.propAppId) {
      this.app_id = this.propAppId
    }

    this.QuizType = QuizType(this.userData.user_role)

    this.qbkCategory()

    if (this.propAppCategory) {
      this.vmQuestionBankFormData.app_category = this.propAppCategory
    }
  },
  methods: {
    /**
     * addOption
     */
    addOption () {
      this.update += 1
      let index = Object.keys(this.vmQuestionBankFormData.answer_choices).length + 1
      let char = String.fromCharCode(96 + index)
      this.vmQuestionBankFormData.answer_choices[char] = ""
    },
    /**
     * removeOption
     * @Params optionNo that need to remove
     * first delete the option then all obj values in sorting order
     * like a,b,c,d and c remove then d will come at place of c
     */
    removeOption (optionNo) {
      let op = {}
      delete this.vmQuestionBankFormData.answer_choices[optionNo]
      const keys = Object.keys(this.vmQuestionBankFormData.answer_choices)

      for (let index = 0; index < keys.length; index++) {
        const char = String.fromCharCode(96 + index + 1)
        op[char] = this.vmQuestionBankFormData.answer_choices[keys[index]]
      }

      this.update += 1
      this.vmQuestionBankFormData.answer_choices = { ...op }
    },
    /**
     * initFormData
     */
    initFormData () {
      return {
        "is_mcq": 1,
        "is_essay_type_numeric": 0,
        "is_allowed_to_img_upload": 0,
        "difficulty": "",
        "skill": "",
        "app_category": "",
        "question": "",
        "correct_answers": "",
        "answer_choices": {},
        question_points: 1
      }
    },
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmQuestionBankFormData) {
          if (!this.vmQuestionBankFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
      }
    },
    /**
     * quizBankAdd
     */
    async quizBankAdd () {
      try {
        this.cvLoadingStatus = true

        if (this.vmQuestionBankFormData.qbk_category_option) {
          this.vmQuestionBankFormData.qbk_category = this.vmQuestionBankFormData.qbk_category_option
        }

        if (this.vmQuestionBankFormData.has_calc) {
          this.vmQuestionBankFormData.has_calc = 1
        }

        if (this.propAppId || this.$route.params.app_id) {
          this.vmQuestionBankFormData.app_id = this.propAppId ? this.propAppId : this.$route.params.app_id
        }

        if (this.vmQuestionBankFormData.answer_explanation) {
          this.vmQuestionBankFormData.answer_explanation = base64encode(this.vmQuestionBankFormData.answer_explanation)
        }

        this.vmQuestionBankFormData.is_essay_type_numeric = this.vmQuestionBankFormData.is_essay_type_numeric === true ? 1 : 0

        this.vmQuestionBankFormData.is_allowed_to_img_upload = this.vmQuestionBankFormData.is_allowed_to_img_upload == true ? 1 : 0

        if (this.vmQuestionBankFormData.serial_no) {
          this.vmQuestionBankFormData.serial_no = Number(this.vmQuestionBankFormData.serial_no)
        }

        let quizBankAddResp = await QuizBanks.quizBankAdd(this, this.vmQuestionBankFormData)
        ApiResponse.responseMessageDisplay(this, quizBankAddResp)
        if (quizBankAddResp && !quizBankAddResp.resp_status) {
          return false
        }

        if (this.isPhotoUploaded) {
          // Add image
          let imageAddResp = await this.imageAdd(quizBankAddResp.resp_data.qbk_id)
          if (imageAddResp && imageAddResp.resp_status) {
            quizBankAddResp.resp_data.image = imageAddResp.resp_data[0].image
          }
          this.isPhotoUploaded = false
        }

        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitCloseQuestionBankAddModal", quizBankAddResp.resp_data)
        }

        this.vmQuestionBankFormData = Object.assign({}, this.initFormData())

        if (this.$route.path != `/quizBank_list/${this.app_id}`) {
          this.$router.push(`/quizBank_list/${this.app_id}`)
        }
      }
      catch (err) {
        console.error("Exception occurred at quizBankAdd() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * question Category Distinct
     */
    async qbkCategory () {
      try {
        let qbkCategoryResp = await QuizBanks.qbkCategory(this, { app_id: this.app_id })
        if (qbkCategoryResp && qbkCategoryResp.resp_status) {
          this.vmqbkcategoryList = qbkCategoryResp.resp_data.data.map(d => d.qbk_category)
        }
      }
      catch (err) {
        console.error("Exception occurred at qbkCategory() and Exception:", err.message)
      }
    },
    /**
     * openImageDialog
     */
    openImageDialog (e, imageType) {
      this.isPhotoUploaded = true
      this.updateImageType = imageType
      if (e.target.files.length > 0) {
        this.fileSrc = e.target.files[0]
      }
      let input = e.target
      if (input.files.length > 0 && input.files[0]) {
        let image = input.files[0]
        let allowedExtension = [ "image/png", "image/jpg", "image/jpeg", "image/webp" ]
        let maxSize = 300 * 1024 // 300 KB in bytes
        if (!allowedExtension.includes(image.type)) {
          if (imageType === "Profile Pic") {
            this.toastMsg = this.cvImageExtensionErrorMsg
            this.showToast = true
          }
          else {
            this.toastMsg = this.cvImageExtensionErrorMsg
            this.showToast = true
          }
          return false
        }
        else if (image.size > maxSize) {
          // validate image size
          if (imageType === "Profile Pic") {
            this.toastMsg = this.cvImageSizeErrorMsg
            this.showToast = true
          }
          else {
            this.toastMsg = this.cvImageSizeErrorMsg
            this.toastVariant = "danger"
            this.showToast = true
          }
          return false
        }
        this.propStencilSize = {
          "width": 1080,
          "height": 566
        }
        this.propCropDialogSize = "md"
        this.propCropImageDialogOpen = Math.random()
      }
    },
    /**
     * getCroppedImg
     */
    getCroppedImg (img) {
      if (this.updateImageType === "Profile Pic") {
        this.vmProfilePic = img
      }
      else {
        this.vmCoverPic = img
      }
    },
    /**
     * emitCroppedImgFile
     */
    emitCroppedImgFile (imgObj) {
      let img = imgObj.imgFile
      let orgImg = imgObj.orgImage
      let imageType = this.updateImageType
      this.onChangeProfileImage(img, imageType)
      this.vmPBACoverPicImage = Object.assign({}, this.initImageData())
      this.vmPBACoverPicImage.image = {
        "img": img,
        "name": orgImg.name
      }
      this.vmPBACoverPicImage.image_type = "cover_pic"
    },

    /**
     * onChangeProfileImage
     */
    onChangeProfileImage (e, imageType) {
      try {
        const reader = new FileReader()
        reader.onload = async (e) => {
          if (imageType === "Profile Pic") {
            this.vmProfilePic = await reader.result
          }
          else {
            this.vmCoverPic = await reader.result
          }
        }
        // reader.readAsDataURL(image)
      }
      catch (err) {
        console.error("Exception occurred at onChangeProfilePic() and Exception:", err.message)
      }
    },
    /**
     * initImageData
     */
    initImageData () {
      return {
        image: "",
        image_type: ""
      }
    },
    /**
     * initPBAData
     */
    initPBAData () {
      return {
        question_name: "",
        module_id: ""
      }
    },
    /**
     * imageAdd
     */
    async imageAdd (pbaId) {
      if (this.cvImageError) {
        return
      }
      try {
        this.cvImageLoadingStatus = true
        let imageObj = {
          "module_name": "QUIZBANK",
          "module_id": pbaId,
          "image": []
        }

        if (this.vmPBACoverPicImage.image) {
          imageObj.image.push(this.vmPBACoverPicImage)
        }

        if (imageObj.image.length < 1) {
          return false
        }

        const imageUpdateResp = await QuizBanks.imageAddToQuizBank(this, imageObj)
        await ApiResponse.responseMessageDisplay(this, imageUpdateResp)
        if (imageUpdateResp && !imageUpdateResp.resp_status) {
          return false
        }
        this.vmPBACoverPicImage = Object.assign({}, this.initPBAData())
        imageObj = {}
        return imageUpdateResp
      }
      catch (err) {
        console.error("Exception occurred at imageAdd() and Exception:", err.message)
        return err
      }
      finally {
        this.cvImageLoadingStatus = false
      }
    },
    /**
     * addCategory
     */
    addCategory (newTag) {
      this.vmqbkcategoryList.push(newTag)
      this.vmQuestionBankFormData.qbk_category_option = newTag
    }
  }
}
</script>
